<template>
  <div class="box">
    <div class="box1">
      <BBtnSecondary
        class="add-btn"
        :clicked="add"
        hidden-key=""
        btn-txt="添加章节"
        :img-src="require('@/assets/new.png')"
      />
      <div class="list_item" v-for="(item, index) in list" :key="index">
        <div class="item_name">{{ item.name }}</div>
        <div class="item_img">
          <img @click="edit(item)" src="@/assets/btn_keshi_edit.png" />
          <img
            @click="deleteOne(item, index)"
            src="@/assets/btn_keshi_del.png"
          />
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="box5">
        <BBtnPrimary class="save-btn" :clicked="doSave" btn-txt="保存" />
      </div>
      <div class="box4">
        <BInputText
          label-text="章节名称"
          :required="true"
          :maxLength="20"
          class="flexstart"
          v-model="addParam.trainLessonName"
          placeholder="请输入名称"
          @changed="changeEditFlag"
        />
        <BInputPullDown
          label-name="章节类型"
          :required="true"
          class="flexstart"
          v-model="addParam.lessonType"
          :Options="pageTypeList"
          @changed="clearAddress"
          placeholder="请选择章节类型"
        />

        <div class="box3">
          <BInputPullDown
            v-if="addParam.lessonType == '02'"
            :required="true"
            label-name="上课地点"
            class="flexstart"
            v-model="addParam.provinceId"
            :Options="provinceList"
            @changed="getCityList"
          />
          <BInputPullDown
            v-if="addParam.lessonType == '02' && cityShowFlag"
            label-name=""
            class="flexstart"
            v-model="addParam.cityId"
            :Options="cityList"
            @changed="getCountyList"
            style="margin-left:-80px;"
          />
          <BInputPullDown
            v-if="addParam.lessonType == '02' && areaShowFlag"
            label-name=""
            class="flexstart"
            v-model="addParam.countyId"
            :Options="countyList"
            @changed="changeEditFlag"
            style="margin-left:-80px;"
          />
        </div>

        <BInputText
          v-if="addParam.lessonType == '02'"
          style="margin-bottom:-10px;"
          :required="true"
          label-text="详细地址"
          class="flexstart"
          v-model="addParam.address"
          placeholder="请输入具体位置"
          @changed="changeEditFlag"
          :inputLength=400
        />
        <BBtnRadio
          v-if="addParam.lessonType != '02'"
          style="margin-top:10px;"
          label-text="快进设置"
          v-model="fastForwardRadioData"
          @input="changeEditFlag"
        />
        <div v-if="addParam.lessonType != '02'" class="item-body">
          <div style="color: #333333;font-size: 14px;">章节简介</div>
          <div>
            <textarea
              class="text-area"
              placeholder="请输入章节简介"
              v-model="addParam.remark"
              @change="changeEditFlag"
            ></textarea>
          </div>
        </div>
        <div v-if="addParam.lessonType != '02'" class="box6">
          <BBtnSecondary
            class="wd-110"
            :img-src="require('@/assets/new.png')"
            :clicked="openUploadVideoPopup"
            btn-txt="上传视频"
          />
        </div>
        <div v-if="addParam.lessonType != '02'" class="box6">
          <BBtnSecondary
            class="wd-110"
            :img-src="require('@/assets/new.png')"
            :clicked="openUploadAudioPopup"
            btn-txt="上传音频"
          />
        </div>
        <div v-if="addParam.lessonType != '02'" class="video-box">
          <div v-if="imgData != null && imgData.length > 0">
            <div class="inner-box">
              <div v-for="(item, index) in imgData" :key="index" class="pt-5">
                <video
                  class="video"
                  :src="item === null ? '' : item.fileUrl"
                  controls
                ></video>
                <img
                  class="delete-img"
                  src="@/assets/circle-delete.png"
                  v-on:click="deleteVideo(index)"
                  alt=""
                />
              </div>
            </div>
            <BProgress v-if="videoFlag" v-model="progress" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  detailInit,
  save,
  getAreaList,
  detail,
  update,
  nameList,
  deletes,
} from "@/api/courseLesson";
import BInputPullDown from "../../components2/BInputPullDown";
import BInputText from "../../components2/BInputText";
import BBtnRadio from "../../components2/BBtnRadio";
import BProgress from "../../components2/BProgress";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Vue from "vue";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Hub from "../../events/Hub";
import PopupContents from "../../views2/sample/PopupContents";
import UploadVideo from "../../views2/sample/UploadVideo";
import UploadAudio from "../../views2/sample/UploadAudio";
const toolbarOptions = [
  ["bold", "italic", "underline"],
  [{ color: [] }, { background: [] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["clean"],
  ["video"],
];
export default {
  name: "StudentManagement",
  components: {
    BInputText,
    BInputPullDown,
    BBtnRadio,
    BProgress,
    BBtnPrimary,
    BBtnSecondary,
  },
  data() {
    return {
      updateSuccess: false,
      data_courseId: "",
      data_lessonId: "",
      data_detailFlg: "0",
      pageTypeList: [],
      provinceList: [],
      teacherList: [],
      cityList: [],
      countyList: [],
      content: "",
      editOptions: {
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              video: function() {
                document.getElementById("uploadVideo").click();
              },
            },
          },
        },
        placeholder: "请在此输入...",
      },
      addParam: {
        trainLessonName: "",
        lessonType: "",
        provinceId: "",
        cityId: "",
        countyId: "",
        address: "",
        remark: "",
        fileUrlList: [],
      },
      snackbar: false,
      timeout: 2000,
      snackbarColor: "success",
      snackbarText: "",
      fastForwardRadioData: {
        checked: "1",
        data: [
          {
            id: "1",
            name: "fastForward",
            label: "支持",
            value: "1",
          },
          {
            id: "2",
            name: "fastForward",
            label: "不支持",
            value: "0",
          },
        ],
      },
      progress: 0,
      videoFlag: false,
      imgData: [],
      list: [],
      deleteId: 0,
      data: {},
      VideoDuration: 0,
      item: "",
      aleardyEditFlag: false,
      areaShowFlag: true,
      cityShowFlag: true,
    };
  },
  props: ["courseId", "lessonId", "detailFlg"],
  async created() {
    // 页面初期化
    this.comUtils.saveStorage(this.$store);
    await this.init();
    if (this.data_detailFlg == "0") {
      if (!this.list[0]) {
        this.list = [
          {
            id: -1,
            name: "默认章节",
          },
        ];
      }
    }
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
    this.data_courseId = this.$route.query.courseId;
    this.data_detailFlg = this.$route.query.detailFlg;
    if (this.$route.query.lessonId) {
      this.data_lessonId = this.$route.query.lessonId;
    }
  },
  methods: {
    add() {
      this.data_detailFlg = "0";
      if (this.list[0]) {
        if (this.list[this.list.length - 1].name == "默认章节") {
          Vue.prototype.$valertbar.show("请点击保存后再继续添加");
          return;
        }
      }

      var templist = {
        id: -1,
        name: "默认章节",
      };
      this.list.push(templist);
      this.addParam = {
        trainLessonName: "",
        lessonType: "01",
        provinceId: "",
        cityId: "",
        countyId: "",
        address: "",
        remark: "",
        fileUrlList: [],
      };
      this.fastForwardRadioData.checked = "1";
      this.imgData = [];
    },
    edit(item) {
      this.item = item;
      if (this.aleardyEditFlag) {
        this.data.bodyText = "页面有未保存的数据，数据将丢失，是否继续？";
        Hub.$emit("open-modal");
        Hub.$emit("set-modal-data", this.data.bodyText, "提示", PopupContents);
      } else {
        if (this.item.name == "默认章节") {
          this.data_detailFlg = "0";
          this.addParam = {
            trainLessonName: "",
            lessonType: "01",
            provinceId: "",
            cityId: "",
            countyId: "",
            address: "",
            remark: "",
            fileUrlList: [],
          };
          this.fastForwardRadioData.checked = "1";
          this.imgData = [];
        } else {
          this.data_lessonId = this.item.id;
          this.data_detailFlg = "1";
          this.imgData = [];
          this.detail();
        }
      }
    },
    deleteOne(item, index) {
      if (this.list.length == 1 && item.name == "默认章节") {
        Vue.prototype.$valertbar.show("默认课时不能删除");
        return;
      }
      if (item.name == "默认章节") {
        this.list.splice(index, 1);
        this.data_lessonId = this.list[0].id;
        this.detail();
      } else {
        this.deleteId = item.id;
        this.data.bodyText = "确认是否删除？";
        Hub.$emit("open-modal");
        Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
      }
    },
    async detail() {
      var param = {
        id: this.data_lessonId,
      };
      const data = await detail(param);
      if (data.data) {
        this.addParam = data.data;
        this.fastForwardRadioData.checked = data.data.fastForwardFlg;
        if (data.data.fileUrlList) {
          this.imgData = data.data.fileUrlList;
        }
        if (this.addParam.lessonType == "02") {
          this.cityList = data.data.cityList;
          if(
            data.data.countyList !== undefined &&
            data.data.countyList !== null &&
            data.data.countyList !== "" 
          ){
              if(data.data.countyList.length === 1 
                 && data.data.countyList[0].value === ''
                 && data.data.countyList[0].text === '' ){
                this.areaShowFlag = false
              }else{
                this.areaShowFlag = true
                this.countyList = data.data.countyList;
              }
          }
          
          
        }
        setTimeout(function() {
          this.aleardyEditFlag = false;
          console.log(this.aleardyEditFlag);
          console.log("zhi");
        }, 1000);
      } else {
        this.data_detailFlg = "0";
        this.addParam = {
          trainLessonName: "",
          lessonType: "01",
          provinceId: "",
          cityId: "",
          countyId: "",
          address: "",
          remark: "",
          fileUrlList: [],
        };
        this.fastForwardRadioData.checked = "1";
        this.imgData = [];
        setTimeout(function() {
          this.aleardyEditFlag = false;
          console.log(this.aleardyEditFlag);
          console.log("zhi");
        }, 1000);
      }
    },
    async init() {
      const data = await detailInit();
      this.pageTypeList = data.data.typeList;
      this.teacherList = data.data.teacherList;
      this.provinceList = data.data.provinceList;
      var param = {
        id: this.data_courseId,
      };
      const data3 = await nameList(param);
      if (data3.data[0]) {
        this.list = data3.data;
        if (this.data_detailFlg == "0") {
          var templist = {
            id: -1,
            name: "默认章节",
          };
          this.list.push(templist);
        }
      } else {
        this.addParam = {
          trainLessonName: "",
          lessonType: "01",
          provinceId: "",
          cityId: "",
          countyId: "",
          address: "",
          remark: "",
          fileUrlList: [],
        };
        this.fastForwardRadioData.checked = "1";
        this.list = [
          {
            id: -1,
            name: "默认章节",
          },
        ];
      }

      if (this.data_detailFlg == "1") {
        this.detail();
      }
      this.aleardyEditFlag = false;
    },
    doSave() {
      if (!this.addParam.trainLessonName) {
        Vue.prototype.$valertbar.show("请输入课时名称");
        return false;
      }
      if (!this.addParam.lessonType) {
        Vue.prototype.$valertbar.show("请选择课时类型");
        return false;
      }
      if (this.addParam.lessonType === "02") {
        if (!(this.addParam.provinceId && this.addParam.address)) {
          Vue.prototype.$valertbar.show("请选择上课地点");
          return false;
        }
        if (this.cityShowFlag && !this.addParam.cityId) {
          Vue.prototype.$valertbar.show("请选择上课地点");
          return false;
        }
        if (this.areaShowFlag && !this.addParam.countyId) {
          Vue.prototype.$valertbar.show("请选择上课地点");
          return false;
        }
      }
      if (this.data_detailFlg == "1") {
        this.update();
      } else {
        this.save();
      }
    },
    async save() {
      var obj = {};
      this.addParam.trainLessonName = this.comUtils.trim(
        this.addParam.trainLessonName
      );
      obj = this.addParam;
      obj.fastForwardFlg = this.radioChecked(this.fastForwardRadioData);
      obj.courseId = this.data_courseId;
      obj.fileUrlList = this.imgData;
      const data = await save(obj);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show("保存成功");
        this.cityShowFlag = true;
        this.areaShowFlag = true;
        this.addParam = {
          trainLessonName: "",
          lessonType: "01",
          provinceId: "",
          cityId: "",
          countyId: "",
          address: "",
          remark: "",
          fileUrlList: [],
        };
        this.fastForwardRadioData.checked = "1";
        this.imgData = [];
        this.init();
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    async update() {
      var obj = {};
      obj = this.addParam;
      obj.fastForwardFlg = this.radioChecked(this.fastForwardRadioData);
      obj.courseId = this.data_courseId;
      obj.id = this.data_lessonId;
      obj.fileUrlList = this.imgData;
      const data = await update(obj);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show("更新成功");
        this.cityShowFlag = true;
        this.areaShowFlag = true;
        this.init();
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    radioChecked(radioData) {
      return radioData.checked;
    },
    deleteVideo(index) {
      this.imgData.splice(index, 1);
      this.aleardyEditFlag = true;
    },
    changeEditFlag() {
      this.aleardyEditFlag = true;
    },
    clearAddress() {
      this.addParam.provinceId = "";
      this.addParam.cityId = "";
      this.addParam.countyId = "";
      this.addParam.address = "";
      this.aleardyEditFlag = true;
    },
    async getCityList(val) {
      this.addParam.cityId = "";
      this.addParam.countyId = "";
      var param = {
        id: val ? val : this.addParam.provinceId,
      };
      const data = await getAreaList(param);
      this.cityList = data.data;
      this.aleardyEditFlag = true;
      if (data.data === null || data.data.length <= 1) {
        this.cityShowFlag = false;
        this.areaShowFlag = false;
      } else {
        this.cityShowFlag = true;
        this.areaShowFlag = true;
      }
    },
    async getCountyList(val) {
      this.addParam.countyId = "";
      var param = {
        id: val ? val : this.addParam.cityId,
      };
      const data = await getAreaList(param);
      this.countyList = data.data;
      this.aleardyEditFlag = true;
      if (data.data === null || data.data.length <= 1) {
        this.areaShowFlag = false;
      } else {
        this.areaShowFlag = true;
      }
    },
    set(value) {
      if (value == 1) {
        // 提示编辑是否跳转
        if (
          this.deleteId == "" ||
          this.deleteId == undefined ||
          this.deleteId == null ||
          this.deleteId == 0
        ) {
          if (this.item.name == "默认章节") {
            this.data_detailFlg = "0";
            this.addParam = {
              trainLessonName: "",
              lessonType: "01",
              provinceId: "",
              cityId: "",
              countyId: "",
              address: "",
              remark: "",
              fileUrlList: [],
            };
            this.imgData = [];
          } else {
            this.data_lessonId = this.item.id;
            this.data_detailFlg = "1";
            this.imgData = [];
            this.detail();
          }
          this.aleardyEditFlag = false;
        }
      }
      if (value == 1) {
        if (
          this.deleteId !== "" &&
          this.deleteId !== undefined &&
          this.deleteId !== null &&
          this.deleteId !== 0
        ) {
          this.delete();
        }
      }
      if (value.fileUrl) {
        this.imgData.push(value);
        this.aleardyEditFlag = true;
      }
    },
    async delete() {
      var param = {
        id: this.deleteId,
      };
      const data = await deletes(param);
      if (data.code === 0) {
        this.data_lessonId = this.list[0].id;
        this.imgData = [];
        this.init();
        Vue.prototype.$vsnackbar.show(data.msg);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
      this.deleteId = 0;
    },
    openUploadVideoPopup() {
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data, "上传视频", UploadVideo);
    },
    openUploadAudioPopup() {
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data, "上传音频", UploadAudio);
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  height: 750px;
  margin-left: 20px;
  padding-top: 30px;
}
.box1 {
  width: 30%;
  margin-right: 20px;
  background: #f9f9f9;
}
.box2 {
  width: 70%;
}
.box3 {
  display: flex;
  margin-top: 15px;
}
.box4 {
  height: 113%;
}
.box5 {
  display: flex;
  justify-content: flex-end;
}
.box6 {
  display: inline-block;
}

.wd-110 {
  width: 110px;
  margin: 20px 20px !important;
}
.add-btn {
  width: 110px;
  margin-bottom: 20px !important;
}
.save-btn {
  width: 110px;
  margin-bottom: 20px !important;
}

.flexstart {
  justify-content: flex-start !important;
}

.video-box {
  display: flex;
  justify-content: flex-start;
  max-height: 362px;
  min-height: 0px;
  margin: 0px 20px 20px 20px;
  overflow: auto;
  overflow-x: hidden;
}

.inner-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.video {
  position: relative;
  width: 260px;
  height: 150px;
  background: #000000;
  margin: 10px;
}

.delete-img {
  position: relative;
  width: 23px;
  height: 23px;
  left: -22px;
  top: -150px;
}
.list_item {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  background: #f4f4f4;
  margin-bottom: 9px;
  cursor: pointer;
  justify-content: space-between;
}
.item_name {
  margin-left: 30px;
  margin-top: 20px;
}
.item_img {
  padding-right: 10px;
  margin-top: 16px;
}
.item_img img {
  margin-right: 5px;
}

.wd-30 {
  width: 30%;
}
.mt-15 {
  margin-left: 0.5%;
  margin-top: 15px;
}
.item-body {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin-left: 25px;
}
.text-area {
  margin-left: 15px;
  width: 300px;
  height: 100px;
  border: 1px solid #dee2e6;
}
.pt-5 {
  padding-top: 5px;
}
</style>
